import { FC, memo } from 'react'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import useObject from '@/hooks/useObject'
import { cn } from '@/lib/utils'
import { useAppSelector } from '@/store'
import { billingUsage } from '@/thunks/billing/usage'
import fadeIn from '@/util/fadeIn'
import { formatNumber } from '@/util/format-number'

const CreditInfo: FC = memo(() => {
  const { app } = useAppSelector()

  const [usage] = useObject(billingUsage, {
    app: app!,
  })

  if (!usage || usage.status !== 'free-trial') return null

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger
          className={
            (cn({
              'text-destructive': usage.credits >= usage.freeTier * 0.8,
            }),
            fadeIn())
          }
          title={`${usage.credits} / ${usage.freeTier}`}
          asChild
        >
          <Button className="flex items-center text-xs text-muted-foreground" variant="outline">
            {formatNumber(usage.credits)} / {formatNumber(usage.freeTier)}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          You&apos;ve used {usage.credits} of your {usage.freeTier} free credits.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
})

CreditInfo.displayName = 'CreditInfo'

export default CreditInfo
